module.exports = __webpack_public_path__ + "img/42_35_440_001.9ebc7c08.jpg";